<template>
  <b-modal v-model="value" size="lg" hide-footer hide-header no-close-on-backdrop>
    <b-container class="modal-content-box" fluid>
      <b-row class="text-center">
        <b-col
          ><p class="title">
            <strong>Select a reason for the change.</strong>
          </p></b-col
        >
      </b-row>
      <b-row class="text-center my-3">
        <b-col>
          <b-form-select v-model="primaryReason" class="mb-3">
            <template slot="first">
              <option :value="''" disabled>Select an option</option>
            </template>
            <option v-for="opt in options" :key="opt" :disabled="!openQueries.length && opt === 'Per Query Resolution'">{{ opt }}</option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="text-center my-3" v-if="primaryReason == 'Per Query Resolution'">
        <b-col>
          <b-row v-if="selectedQuery" class="selectBox selectedBox">
            <span class="d-inline-block truncate selected-filter" @click="showQueries">{{ selectedQueryName }}</span>
          </b-row>
          <b-row class="selectBox" @click="showQueries" v-else>
            <select class="query-type-select">
              <option value selected="selected">Select Query</option>
            </select>
            <b-row class="overSelect"></b-row>
          </b-row>
          <b-row v-if="isDisplayQuery" id="showQueries">
            <b-form-input type="text" class="query-search-bar" placeholder="Search for query" v-model="searchedQuery"></b-form-input><br />
            <div class="query-list" v-for="query in searchedQueryList" :key="query.queryId" @click="getSelectedQuery(query)">
              <label
                ><strong>{{ query.sequenceNo }} {{ query.comments[0].createdBy }}</strong></label
              ><br />
              <label class="truncate"
                ><small>{{ query.comments[0].cText }}</small></label
              >
            </div>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="text-center my-3">
        <b-col>
          <button-cmp variant="primary" @click="confirmAction" class="button" :disabled="(primaryReason === 'Per Query Resolution' && !selectedQuery) || !primaryReason">Confirm data change</button-cmp>
        </b-col>
      </b-row>
      <b-row class="text-center my-3">
        <b-col>
          <button-cmp @click="cancelAction" class="button">Cancel changes</button-cmp>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import ButtonCmp from "@/components/common/button";
import _ from "lodash";

export default {
  name: "form-change-reason-modal",
  components: { ButtonCmp },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    openQueries: {
      type: Array
    }
  },
  data() {
    return {
      primaryReason: "",
      options: [],
      selectedQuery: "",
      searchedQuery: "",
      selectedQueryName: "",
      isDisplayQuery: false
    };
  },
  methods: {
    confirmAction() {
      this.$emit("confirmed", this.primaryReason, this.selectedQuery);
      this.primaryReason = "";
      this.selectedQuery = "";
      this.isDisplayQuery = false;
      this.closeModal();
    },
    cancelAction() {
      this.primaryReason = "";
      this.selectedQuery = "";
      this.isDisplayQuery = false;
      this.$emit("canceled");
      this.closeModal();
    },
    closeModal() {
      this.$emit("input", false);
    },
    showQueries() {
      this.isDisplayQuery = !this.isDisplayQuery;
      this.searchedQuery = "";
    },
    getSelectedQuery(query) {
      this.selectedQuery = query.queryId;
      this.selectedQueryName = query.sequenceNo + " " + query.comments[0].createdBy;
      this.isDisplayQuery = false;
    }
  },
  computed: {
    searchedQueryList() {
      if (!this.openQueries) {
        return [];
      }
      if (!this.openQueries.length) {
        return [];
      }

      const searchedQuery = this.searchedQuery.toLowerCase();
      const openQueries = this.openQueries.filter(query => {
        return query.comments[0].createdBy.toLowerCase().includes(searchedQuery) || query.comments[0].cText.toLowerCase().includes(searchedQuery) || query.sequenceNo.toString().includes(searchedQuery);
      });
      return _.sortBy(openQueries, "createdBy");
    }
  },
  mounted() {
    this.$api
      .getFormReasonForChangeList()
      .then(result => {
        this.options = result.body || [];
      })
      .catch(error => {
        const { message = "Error while loading available reason for change variants" } = (error && error.body) || {};
        this.$toastr.error(message);
      });
  }
};
</script>

<style scoped>
.modal-content-box {
  padding: 25px;
  min-width: 300px !important;
}
.title {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}
.button {
  text-transform: none !important;
  border-radius: 25px;
  width: 75%;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}
.query-search-bar {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.query-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  border-radius: 3px;
  background-color: #ffff;
  color: #666669;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.selectBox {
  position: relative;
  border: 1px solid lightgray;
  border-radius: 4px;
}
.selectedBox {
  padding: 8px;
  text-align: left;
}
#showQueries {
  background: #fff;
  position: absolute;
  width: 88%;
  border-radius: 3px;
  padding: 10px;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  top: 3%;
  overflow-y: scroll;
  max-height: 300px;
}
#showQueries label {
  float: left;
  margin-bottom: 0px;
}
.query-list {
  width: 100%;
  cursor: pointer;
}
.query-list:hover {
  background-color: #1e8fe1;
  color: white !important;
}
.selected-filter {
  width: 80%;
  cursor: pointer;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(90%);
}
</style>
